import { render, staticRenderFns } from "./CollapseParaListagem.vue?vue&type=template&id=198fad96&scoped=true"
import script from "./CollapseParaListagem.vue?vue&type=script&lang=js"
export * from "./CollapseParaListagem.vue?vue&type=script&lang=js"
import style0 from "./CollapseParaListagem.vue?vue&type=style&index=0&id=198fad96&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198fad96",
  null
  
)

export default component.exports